import {
  Box,
  Checkbox,
  Divider,
  Grid2,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import MenuItemMui from "@mui/material/MenuItem";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { useMemo, useState } from "react";
import { CalendarMonthOutlined, CancelOutlined } from "@mui/icons-material";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Colombo");

const InterlockPavingReportDetails = ({
  addTestHandle,
  eachTest,
  mainData,
  setMainData,
  isNonMobile,
}) => {
  const colorOfInterlock = [
    { id: "None", label: "None", value: "None" },
    { id: "Black", label: "Black", value: "Black" },
    { id: "Red", label: "Red", value: "Red" },
    { id: "Green", label: "Green", value: "Green" },
    { id: "Gray", label: "Gray", value: "Gray" },
  ];

  const interlockHeight = [
    { id: "60", label: "60", value: "60" },
    { id: "80", label: "80", value: "80" },
    { id: "100", label: "100", value: "100" },
  ];

  const interlockType = [
    { id: 1, label: "Plain Block", value: "Plain Block" },
    {
      id: 2,
      label: "Chamfered Block",
      value: "Chamfered Block",
    },
  ];

  const handleDateOfCast = (newVal) => {
    setMainData((pre) => ({
      ...pre,
      dateOfCast: dayjs(newVal).format("YYYY-MM-DD"),
    }));
    // setDatDiff(calculateDaysBetween);
  };

  const handleDateOfTest = (newVal) => {
    setMainData((pre) => ({
      ...pre,
      dateOfTest: dayjs(newVal).format("YYYY-MM-DD"),
    }));
    // setDatDiff(calculateDaysBetween);
  };

  const [errorCheck, setErrorCheck] = useState({
    serialNo: {
      error: false,
    },
    dateOfCast: {
      error: false,
    },
    dateOfTest: {
      error: false,
    },
    weight: {
      error: false,
    },
    concreteMixture: {
      error: false,
    },
    areaOfCube: {
      error: false,
    },
    compressiveStrength: {
      error: false,
    },
  });

  const checkFieldsHandle = () => {
    if (mainData.concreteMixture === "") {
      setErrorCheck((pre) => ({
        ...pre,
        concreteMixture: {
          ...pre.concreteMixture,
          error: true,
        },
      }));
      return;
    } else {
      setErrorCheck((pre) => ({
        ...pre,
        concreteMixture: {
          ...pre.concreteMixture,
          error: false,
        },
      }));
    }

    if (mainData.areaOfCube === "") {
      setErrorCheck((pre) => ({
        ...pre,
        areaOfCube: {
          ...pre.areaOfCube,
          error: true,
        },
      }));
      return;
    } else {
      setErrorCheck((pre) => ({
        ...pre,
        areaOfCube: {
          ...pre.areaOfCube,
          error: false,
        },
      }));
    }

    if (eachTest.weight === "") {
      setErrorCheck((pre) => ({
        ...pre,
        weight: {
          ...pre.weight,
          error: true,
        },
      }));
      return;
    } else {
      setErrorCheck((pre) => ({
        ...pre,
        weight: {
          ...pre.weight,
          error: false,
        },
      }));
    }
    if (eachTest.compressiveStrength === "") {
      setErrorCheck((pre) => ({
        ...pre,
        compressiveStrength: {
          ...pre.compressiveStrength,
          error: true,
        },
      }));
      return;
    } else {
      setErrorCheck((pre) => ({
        ...pre,
        compressiveStrength: {
          ...pre.compressiveStrength,
          error: false,
        },
      }));
    }
    // console.log("maindata", mainData);

    addTestHandle();
  };
  const handleRemoveSeleced = (deleteObj) => {
    const newArrya = mainData.labTestsDataFromSubs.filter(
      (ele) => ele.serialNo !== deleteObj
    );

    setMainData((pre) => ({
      ...pre,
      labTestsDataFromSubs: newArrya,
    }));
  };

  const handleSetWeight = (serialNo, weight) => {
    let factor = 0;

    if (mainData.height === "60" && mainData.interlockType === "Plain Block") {
      factor = 1;
    } else if (
      mainData.height === "80" &&
      mainData.interlockType === "Plain Block"
    ) {
      factor = 1.12;
    } else if (
      mainData.height === "100 " &&
      mainData.interlockType === "Plain Block"
    ) {
      factor = 1.18;
    } else if (
      mainData.height === "60" &&
      mainData.interlockType === "Chamfered Block"
    ) {
      factor = 1.06;
    } else if (
      mainData.height === "80" &&
      mainData.interlockType === "Chamfered Block"
    ) {
      factor = 1.18;
    } else if (
      mainData.height === "100" &&
      mainData.interlockType === "Chamfered Block"
    ) {
      factor = 1.24;
    }

    // console.log("Weight ", weight);
    // console.log("factor ", factor);
    // console.log("interlock type ", mainData.interlockType);
    // console.log("height ", mainData.height);

    setMainData((pre) => ({
      ...pre,
      labTestsDataFromSubs: pre.labTestsDataFromSubs.map((test) =>
        test.serialNo === serialNo
          ? {
              ...test,
              weight: weight,
              compressiveStrength: (
                (Number(weight) / Number(pre.areaOfCube)) *
                Number(factor) *
                1000
              ).toFixed(2),
            }
          : test
      ),
    }));
  };

  const handleSetColor = (serialNo, color) => {
    setMainData((pre) => ({
      ...pre,
      labTestsDataFromSubs: pre.labTestsDataFromSubs.map((test) =>
        test.serialNo === serialNo ? { ...test, color: color } : test
      ),
    }));
  };

  const handleCompressiveStrength = (serialNo, compressiveStrength) => {
    setMainData((pre) => ({
      ...pre,
      labTestsDataFromSubs: pre.labTestsDataFromSubs.map((test) =>
        test.serialNo === serialNo
          ? { ...test, compressiveStrength: compressiveStrength }
          : test
      ),
    }));
  };
  const label = { slotProps: { input: { "aria-label": "Checkbox demo" } } };
  const daysDifference = useMemo(() => {
    if (!mainData.dateOfCast || !mainData.dateOfTest) return null;

    const castDate = dayjs(mainData.dateOfCast);
    const testDate = dayjs(mainData.dateOfTest);

    return testDate.diff(castDate, "day");
  }, [mainData.dateOfCast, mainData.dateOfTest]);
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        display="grid"
        gap={0.5}
        alignItems="center"
        gridTemplateColumns="repeat(6, minmax(0, 1fr))"
        sx={{
          "& > div": {
            gridColumn: isNonMobile ? undefined : "span 6",
          },
        }}
      >
        <Box display="flex" sx={{ paddingTop: "5px", gridColumn: "span 1" }}>
          <Box display="flex" textAlign="center" alignItems="center">
            <Checkbox
              {...label}
              icon={<CalendarMonthOutlined color="info" />}
              checkedIcon={<CancelOutlined />}
              color="warning"
              onChange={(e) => {
                setMainData((pre) => ({
                  ...pre,
                  showDateOfCast: e.target.checked,
                }));
              }}
            />
            <Typography>
              {mainData.showDateOfCast ? "" : "Show Date of Cast"}
            </Typography>
          </Box>
          {mainData.showDateOfCast ? (
            <DemoContainer
              components={["DatePicker"]}
              sx={{ paddingTop: "5px", gridColumn: "span 1" }}
              variant="outlined"
            >
              <div style={{ width: "190px" }}>
                <DatePicker
                  sx={{
                    width: "100%",
                    "& .MuiInputBase-root": {
                      height: "40px",
                      overflow: "hidden",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                  }}
                  slotProps={{
                    textField: {
                      variant: "outlined",
                      size: "small",
                    },
                  }}
                  label="Date of cast"
                  size="small"
                  format="YYYY-MM-DD"
                  timezone="Asia/Colombo"
                  // error={errorCheck.dateOfCast.error}
                  value={
                    mainData.dateOfCast
                      ? dayjs(mainData.dateOfCast).tz("Asia/Colombo", true)
                      : dayjs().tz("Asia/Colombo", true)
                  }
                  onChange={(newVal) => {
                    const colomboTime = newVal?.tz("Asia/Colombo", true);
                    handleDateOfCast(colomboTime);
                  }}
                />
              </div>
            </DemoContainer>
          ) : (
            ""
          )}
        </Box>

        <DemoContainer
          alignContent="center"
          components={["DatePicker"]}
          sx={{ paddingTop: "5px", gridColumn: "span 1" }}
        >
          <Box style={{ width: "190px" }}>
            <DatePicker
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  height: "40px",
                  overflow: "hidden",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              }}
              slotProps={{
                textField: {
                  variant: "outlined",
                  size: "small",
                },
              }}
              label="Date of test"
              timezone="Asia/Colombo"
              format="YYYY-MM-DD"
              // error={errorCheck.dateOfTest.error}
              value={
                mainData.dateOfTest
                  ? dayjs(mainData.dateOfTest).tz("Asia/Colombo", true)
                  : dayjs().tz("Asia/Colombo", true)
              }
              onChange={(newVal) => {
                const colomboTime = newVal?.tz("Asia/Colombo", true);
                handleDateOfTest(colomboTime);
              }}
            />
          </Box>
        </DemoContainer>
        <Typography
          textAlign="center"
          color="success"
          variant="h4"
          sx={{ paddingTop: "5px", gridColumn: "span 1" }}
        >
          {mainData.showDateOfCast ? `${daysDifference} Day(s)` : ""}
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          select
          type="number"
          label="Height(mm)"
          size="small"
          value={mainData.height}
          onChange={(e) =>
            setMainData((pre) => ({
              ...pre,
              height: e.target.value,
              labTestsDataFromSubs: pre.labTestsDataFromSubs.map((test) => ({
                ...test,
                weight: "0.00",
                compressiveStrength: "0.00",
              })),
            }))
          }
          sx={{ gridColumn: "span 1", marginTop: "5px" }}
        >
          {interlockHeight.map((data) => (
            <MenuItemMui
              key={data.id}
              data-label={data.label}
              value={data.value}
            >
              {data.label}
            </MenuItemMui>
          ))}
        </TextField>
        <TextField
          fullWidth
          variant="outlined"
          select
          label="Interlock Type"
          defaultValue=""
          size="small"
          value={mainData?.interlockType ? mainData?.interlockType : ""}
          onChange={(e) =>
            setMainData((pre) => ({
              ...pre,
              interlockType: e.target.value,
              labTestsDataFromSubs: pre.labTestsDataFromSubs.map((test) => ({
                ...test,
                weight: "0.00",
                compressiveStrength: "0.00",
              })),
            }))
          }
          sx={{ gridColumn: "span 1", marginTop: "5px" }}
        >
          {interlockType.map((data) => (
            <MenuItemMui
              key={data.id}
              data-label={data.label}
              value={data.value}
            >
              {data.label}
            </MenuItemMui>
          ))}
        </TextField>
        <TextField
          fullWidth
          variant="outlined"
          type="number"
          label="Effective Area of Cube"
          name="areaOfCube"
          size="small"
          error={errorCheck.areaOfCube.error}
          sx={{ marginTop: "5px", gridColumn: "span 1" }}
          value={mainData.areaOfCube}
          onChange={(e) =>
            setMainData((pre) => ({
              ...pre,
              areaOfCube: e.target.value,
              labTestsDataFromSubs: pre.labTestsDataFromSubs.map((test) => ({
                ...test,
                weight: "0.00",
                compressiveStrength: "0.00",
              })),
            }))
          }
        />
      </Box>
      <Divider sx={{ margin: "5px 0px 5px 0" }} />

      <Box justifyItems="center">
        <Paper variant="elevation" elevation={2} sx={{ padding: "20px" }}>
          {mainData.labTestsDataFromSubs?.map((data, index) => (
            <Grid2 container columnSpacing={0.5} width="100%">
              <Grid2 size={2} alignContent="center">
                <Typography variant="subtitle1" color="info" textAlign="center">
                  SERIAL NO
                </Typography>

                <Typography variant="h5" textAlign="center">
                  {data.serialNo === undefined
                    ? "AUTO"
                    : String(data.serialNo).padStart(3, "0")}
                </Typography>
              </Grid2>
              <Grid2 size={3} alignContent="center">
                <TextField
                  select
                  label="Color"
                  fullWidth
                  size="small"
                  defaultValue=""
                  sx={{ marginTop: "5px", gridColumn: "span 2" }}
                  value={data.color}
                  onChange={(e) => {
                    const selectedValue = e.target.value;
                    handleSetColor(data.serialNo, selectedValue);
                  }}
                >
                  {colorOfInterlock.map((data) => (
                    <MenuItemMui
                      key={data.id}
                      data-label={data.label}
                      value={data.value}
                    >
                      {data.label}
                    </MenuItemMui>
                  ))}
                </TextField>
              </Grid2>
              <Grid2 size={3} alignContent="center">
                <TextField
                  value={data.weight}
                  fullWidth
                  variant="outlined"
                  label="Load (kN)"
                  onChange={(e) =>
                    handleSetWeight(data.serialNo, e.target.value)
                  }
                  type="number"
                  size="small"
                  sx={{
                    marginTop: "5px",
                    "& input": {
                      textAlign: "right",
                    },
                  }}
                />
              </Grid2>

              <Grid2 size={4} alignContent="center">
                <TextField
                  value={data.compressiveStrength}
                  fullWidth
                  disabled
                  variant="outlined"
                  label="Compressive Strength"
                  type="number"
                  size="small"
                  onChange={(e) =>
                    handleCompressiveStrength(data.serialNo, e.target.value)
                  }
                  sx={{
                    marginTop: "5px",
                    "& input": {
                      textAlign: "right",
                    },
                  }}
                />
              </Grid2>
              {/* <Grid2 size={2} justifyItems="center">
                <Box>
                  <IconButton
                    onClick={() => handleRemoveSeleced(data.serialNo)}
                    color="error"
                    aria-label="delete"
                  >
                    <Delete />
                  </IconButton>
                </Box>
              </Grid2> */}
              <Grid2 size={12} justifyItems="center">
                <Divider width="100%" />
              </Grid2>
            </Grid2>
          ))}
        </Paper>
      </Box>
    </LocalizationProvider>
  );
};

export default InterlockPavingReportDetails;
